export default "__VITE_ASSET__b9e7eb43__"